/** @jsx h */
/* eslint camelcase: ["error", {ignoreDestructuring: true}] */
import { h } from 'preact'
import { format } from 'date-fns'
import { de } from 'date-fns/locale'
import cls from 'classnames'
import I18n from 'i18n-js/index.js.erb'

const TIME_FORMAT = 'HH:mm'
const DATE_FORMAT = 'EEEEEE - dd.MM.yyyy'

const VenueShow = ({ urls, loading, error, data }) => {
  if (error) {
    return (
      <div class="appointment-map__venue-detail alert alert-danger">
        <i class="fa fa-exclamation-triangle mr-4"></i>
        Es ist ein Fehler aufgetreten.
      </div>
    )
  }

  if (loading) {
    return (
      <div class="appointment-map__venue-detail alert alert-info">
        <i class="fa fa-spinner fa-spin mr-4"></i>
        Bitte warten
      </div>
    )
  }

  const { city, zip, location, street, appointments, donation_service } = data

  return (
    <div class="appointment-map__venue-detail">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-6">
          <address>
            {city} {zip}<br />
            <strong>{location}</strong><br />
            {street}<br />
          </address>
        </div>
          {appointments.map(({ id, start_on, start_time, end_time, start_time_second, end_time_second, donation_reservation_reservable, donation_service }) => (
          <div class="col-lg-3 col-md-4 col-6 d-flex align-items-stretch">
            <a href={urls.appointment({ id })} class="font-weight-normal d-flex align-items-stretch w-100">
              <div class="box darkred p-2 mb-4 w-100">
                <i class="fa fa-info-circle float-right fa-2x"></i>
                <strong>{format(new Date(start_on), DATE_FORMAT, { locale: de })}</strong><br /> {format(new Date(start_time), TIME_FORMAT, { locale: de })} Uhr &ndash; {format(new Date(end_time), TIME_FORMAT, { locale: de })} Uhr
            { !!(start_time_second) && !!(end_time_second)
                ? [
                <br/>,
                format(new Date(start_time_second), TIME_FORMAT, { locale: de }),
                " ",
            <span>&ndash;</span>,
              " ",
                  format(new Date(end_time_second), TIME_FORMAT, { locale: de }),' Uhr'
            ]
            : ''
            }
          <br />
          { donation_reservation_reservable ? <strong>{ I18n.t('javascripts.appointment_search.components.venue_show.donation_reservation_text.' + donation_service, { defaultValue: I18n.t('javascripts.appointment_search.components.venue_show.donation_reservation_text.default') }) }</strong> : '' }
          { donation_service == 'bawuehe' && !donation_reservation_reservable ? <div><strong>{ I18n.t('javascripts.appointment_search.components.venue_show.no_donation_reservation_available.bawuehe') }</strong></div> : '' }
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default VenueShow
